import React, { useState } from 'react';
import { Text, View, Pressable } from 'react-native';
import { SALE } from './queries';
import { useQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import SubNav from './SubNav';
import {
  MainContainer,
  ContentContainer,
  TableContainer,
  TitleContainer,
  PageTitle,
} from '../../elements';
import moment from 'moment';
import Modal from '../../elements/Modal';
import EditSale from './edit';
import styled from 'styled-components/native';
import AchBatchModal from './AchBatchModal';

import { useParams } from 'app/src/utils/routing';

import SaleProcess from './Process';
import BidFunctionsLegend from './Process/BidFunctionsLegend';
import { getStatus, getStatusType } from './elements';

const SaleDetails = styled(View)`
  display: flex;
  justify-content: flex-end;
  text-align: end;
`;

const DetailsText = styled(Text)`
  text-align: end;
`;

const PageTitleStatusContainer = styled(View)`
  display: flex;
  flex-direction: row;
`;

export const StatusContainer = styled(Pressable)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  height: 40px;
  width: fit-content;
  padding: 20px;
  margin-left: 40px;
  margin-top: -5px;
`;

const StatusText = styled(Text)`
  color: #fff;
  font-weight: bold;
`;

const WarningText = styled(Text)`
  margin-left: 20px;
  color: red;
  font-size: 24px;
  font-weight: 900;
`;

const Sale = () => {
  let { id, tableType, saleAssetId } = useParams();
  const [showEditSaleStatusModal, setShowEditSaleStatusModal] = useState(false);
  const [showAchBatchModal, setShowAchBatchModal] = useState(false);

  const { loading, data, refetch } = useQuery(
    SALE, { variables: { id } }
  );

  if (loading) {
    return <DataState.Loading />;
  }

  const { sale } = data;

  if (!tableType) { tableType = getStatus(sale?.status, true); }
  const buttonStyle = { backgroundColor: getStatusType(sale.status) };

  const saleInFuture = moment(sale.saleOn).diff(moment(), 'days') > 0;

  return (
    <MainContainer>
      <ContentContainer>
        <TitleContainer id="titlecontainer">
          <PageTitleStatusContainer>
            <PageTitle>{sale?.name}</PageTitle>
            <StatusContainer
              style={buttonStyle}
              onPress={() => setShowEditSaleStatusModal(true)}
            >
              <StatusText>{sale?.status}</StatusText>
            </StatusContainer>
            {['post', 'live'].includes(tableType) && saleInFuture && (
              <WarningText>Warning: Sale is not yet started!</WarningText>
            )}
          </PageTitleStatusContainer>
          <SaleDetails>
            <DetailsText>
              Pre-Bid: <b>{moment(sale?.preBidOpenAt)?.format('MM-DD-YY \\@ hh:mmA')}</b>
            </DetailsText>
            <DetailsText>
              Starts: <b>{moment(sale?.startAt)?.format('MM-DD-YY \\@ hh:mmA')}</b>
            </DetailsText>
            <DetailsText>
              Ends: <b>{moment(sale?.endAt)?.format('MM-DD-YY \\@ hh:mmA')}</b>
            </DetailsText>
            {sale?.saleType === 'Timed' &&
              <>
                <DetailsText>
                  Initial Time Per Lot (Seconds): <b>{sale?.initialTime}</b>
                </DetailsText>
                <DetailsText>
                  Retrigger Time Per Lot (Seconds): <b>{sale?.retriggerTime}</b>
                </DetailsText>
                <DetailsText>
                  Add Time Per Lot (Seconds): <b>{sale?.addTime}</b>
                </DetailsText>
              </>
            }
          </SaleDetails>
        </TitleContainer>
        <TableContainer>
          <SubNav
            sale={sale}
            withNav={false}
            tableType={tableType}
            setShowAchBatchModal={setShowAchBatchModal}
          />
          {'pre' !== tableType && <BidFunctionsLegend />}
          <SaleProcess
            sale={sale}
            saleId={id}
            tableType={tableType}
            linkedSaleAssetId={saleAssetId}
          />
        </TableContainer>
      </ContentContainer>
      {showEditSaleStatusModal &&
        <Modal
          refetch={refetch}
          showModal={showEditSaleStatusModal}
          setShowModal={setShowEditSaleStatusModal}
          modalType={'Change Sale Status'}
          objectName={sale.name}
        >
          <EditSale
            setShowModal={setShowEditSaleStatusModal}
            refetch={refetch}
            sale={sale}
            statusUpdate={true}
          />
        </Modal>
      }
      {showAchBatchModal &&
        <Modal
          setShowModal={setShowAchBatchModal}
          modalType="Current ACH Batch"
        >
          <AchBatchModal
            setShowModal={setShowAchBatchModal}
            editable={true}
            noExcel={true}
            noPdf={true}
          />
        </Modal>
      }
    </MainContainer>
  );
};

export default Sale;